import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { VehicleDTO } from "@shared/model/vehicle.model";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";
import { WcmService } from "@shared/services/wcm/wcm.service";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

Swiper.use([Navigation]);

@Component({
	selector: "vehicle-slider",
	standalone: true,
	templateUrl: "./vehicle-slider.component.html",
	styleUrl: "./vehicle-slider.component.scss"
})
export class VehicleSliderComponent implements OnDestroy, OnInit {
	@Input() vehicles: VehicleDTO[];

	@ViewChild("swiperContainer", { static: true }) swiperContainer!: ElementRef<HTMLElement>;
	@ViewChild("prevBtn", { static: true }) prevBtn!: ElementRef<HTMLElement>;
	@ViewChild("nextBtn", { static: true }) nextBtn!: ElementRef<HTMLElement>;

	private swiper!: Swiper;

	constructor(
		public wcmService: WcmService,
		public utils: ClickarUtilsService
	) { }

	ngOnInit() {
		this.initSwiper();
	}

	initSwiper() {
		this.swiper = new Swiper(this.swiperContainer.nativeElement, {
			modules: [Navigation],
			slidesPerView: "auto",
			slidesPerGroup: 1,
			spaceBetween: 30,
			direction: "horizontal",
			centeredSlidesBounds: true,
			navigation: {
				nextEl: this.nextBtn.nativeElement,
				prevEl: this.prevBtn.nativeElement
			},
		});

		this.prevBtn.nativeElement.style.display = "none";

		this.swiper.on("slideChange", () => {
			this.updateNavigationButtons();
		});
	}

	updateNavigationButtons() {
		if (this.prevBtn && this.nextBtn) {
			// Hide prev if on first slide
			this.prevBtn.nativeElement.style.display = this.swiper.isBeginning ? "none" : "block";

			// Hide next if on last slide
			this.nextBtn.nativeElement.style.display = this.swiper.isEnd ? "none" : "block";
		}
	}

	onNext() {
		this.swiper?.slideNext();
	}

	onPrev() {
		this.swiper?.slidePrev();
	}

	ngOnDestroy(): void {
		this.swiper?.destroy();
	}
}